/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getSurveyConfig,
  updateSurveyConfig
} from '../actions/api';
import { SurveyConfig } from '../types/surveyConfig';

interface InitialState {
  surveyId: string | undefined;
  data: SurveyConfig | undefined;
  loaded: boolean;
  errored: boolean;
  errorMessage: string;
}

const initialState: InitialState = {
  surveyId: undefined,
  data: undefined,
  loaded: false,
  errored: false,
  errorMessage: '',
};

const surveyConfigSlice = createSlice({
  name: 'surveyConfig',
  initialState: initialState,
  reducers: {
    loadConfig: (state, action) => {
      return { ...state, surveyId: action.payload, errored: false, errorMessage: '' };
    },
    updateConfig: (state, action) => {
      return { ...state, surveyId: action.payload, errored: false, errorMessage: '' };
    },
    // Can pass adapter functions directly as case reducers.  Because we're passing this
    // as a value, `createSlice` will auto-generate the `valueListAdded` action type / creator
    loadedConfig: (state, action) => {
      return { ...state, loaded: true, data: action.payload, errored: false, errorMessage: '' }
    },
    error: (state, action: PayloadAction<Error>) => {
      return { ...state, errored: true, errorMessage: action.payload.message };
    }
  }
})

export const { loadConfig, loadedConfig, updateConfig, error } = surveyConfigSlice.actions

export default surveyConfigSlice.reducer

export const loadConfigById = (id: string): any => async (dispatch: any, getState: () => any) => {

  const state = getState();
  if (id === state.surveyId && state.loaded) {
    return;
  }

  dispatch(loadConfig(id));

  getSurveyConfig(id).then(
    (config) => {
      dispatch(loadedConfig(config))
    },
    (err: Error) => {
      dispatch(error(err));
    }
  )
}

export const updateConfigById = (id: string, data: any): any => async (dispatch: any, getState: () => any) => {

  const state = getState();
  if (id === state.surveyId && state.loaded) {
    return;
  }

  dispatch(updateConfig(id));
  return updateSurveyConfig(id, data)
    .then((config: SurveyConfig) => dispatch(loadedConfig(config)),
  )
}
